import { isFilterApplied } from "../../../../components/filters/OpportunitySearchFilter/filterConfig"

export const checkIsFilterUsed = ({ searchParamGroup }) =>
  isFilterApplied(searchParamGroup)
